export default {
  campaignIntel: 'Campaign Intel',
  threatKnowledgebase: 'Threat Knowledgebase',
  toolbar: {
    clearFilters: 'Clear Filters',
    search: 'Search',
    items: 'Items'
  },
  table: {
    campaignName: 'Campaign Name',
    discoveryDate: 'Discovery Date',
    attribution: 'Attribution',
    malware: 'Malware',
    sectors: 'Sectors',
    countries: 'Countries',
    na: 'N/A'
  },
  filtersFields: {
    discoveryDate: 'Discovery Date',
    attribution: 'Attribution',
    sector: 'Sector',
    country: 'Country'
  },
  filters: 'Filters',
  errors: {
    failedToFetch: 'Failed to fetch data. Please try again',
    search: 'Enter at least 3 characters',
    failed_export_csv: 'Failed to export CSV file'
  },
  campaignCard: {
    errors: {
      failedToFetchCampaign: 'Failed to fetch campaign',
      failedToFetchIocs: 'Failed to fetch IOCs',
      failedToFetchCves: 'Failed to fetch CVEs',
      failedToFetchReports: 'Failed to fetch Reports',
      failedToFetchVictimology: 'Failed to fetch Victimology'
    },
    na: 'N/A',
    header: {
      firstSeen: 'First Seen',
      topTargetedCountries: 'Top Targeted Countries',
      malwares: 'Malwares',
      attribution: 'Attribution',
      topTargetedSectors: 'Top Targeted Sectors',
      vulnHosts: 'Vulnerable Hosts',
      securityControls: 'Security Controls',
      iocPosture: 'IOC Posture'
    },
    tabs: {
      summary: 'Summary',
      attribution: 'Attribution',
      malwares: 'Malwares',
      cves: 'CVEs',
      ttps: 'TTPs',
      iocs: 'IOCs',
      news: 'News',
      reports: 'Reports & Advisories',
      victimology: 'Victimology'
    },
    attribution: {
      columns: {
        name: 'Threat Actor Name',
        type: 'Type',
        motivation: 'Motivation',
        topTargetedSectors: 'Top Targeted Sectors',
        topTargetedCountries: 'Top Targeted Countries',
        lastSeen: 'Last Seen'
      }
    },
    malwares: {
      columns: {
        name: 'Malware Name',
        type: 'Type',
        motivation: 'Motivation',
        firstSeen: 'First Seen',
        lastSeen: 'Last Seen'
      }
    },
    ttps: {
      columns: {
        tactic: 'Tactic',
        technique: 'Technique'
      },
      card: {
        tactic: 'Tactic',
        technique: 'Technique',
        detection: 'Detection',
        mitigation: 'Mitigation',
        download_button_tooltip: 'Export all TTPs to a .csv report file'
      }
    },
    cves: {
      columns: {
        cveId: 'CVE ID',
        score: 'Score',
        description: 'Description',
        published: 'Published',
        vulnHosts: 'Vulnerable Hosts',
        securityControls: 'Security Controls',
        vpatch: 'IOC Posture',
        exploitedBy: 'Exploited By',
        products: 'Products'
      }
    },
    news: {
      news: 'News',
      columns: {
        date: 'Date',
        type: 'Type',
        title: 'Title'
      },
      country: 'Country',
      sector: 'Sector',
      description: 'Description'
    },
    iocs: {
      unExpired: 'Active IOCs',
      download_button_tooltip: 'Export all {{total_count}} IOCs to a .xlsx report file',
      columns: {
        type: 'Type',
        value: 'Value',
        date: 'Date',
        expirationDate: 'Blocking Expiration',
        postureStatus: 'Posture Status',
        installedOn: 'Installed On',
        lastSeen: 'Last Seen'
      },
      source: {
        checkPoint: 'Source: Check Point',
        external: 'Source: External'
      }
    },
    reports: {
      actions: {
        openSource: 'Open Source',
        viewReport: 'View Report',
        download: 'Download'
      },
      externalSource: 'External Source',
      publishDate: 'Publish Date'
    }
  }
};
